export const menuSymbol = {
    1: { name: '视频', logName: 'PHOTO' },
    2: { name: '用户', logName: 'AUTHOR' },
    8: { name: '评论', logName: 'COMMENT' },
} as const;

export interface ReportOption {
    reportType: keyof typeof menuSymbol;
    page: string;
    targetId: string;
    reportedUserId: string;
    extraPhotoId?: string;
}